<template>
  <section class="section">
    <div class="card">
      <div
        class="card-content has-background-grey-light has-text-black-bis header"
      >
        <h2 class="title">Demonstrativo de pagamentos</h2>
      </div>
      <div class="body-content ml-3 mr-3 mt-5 mb-5">
        <h3>
          <strong>Administradora/Operadora: </strong
          >{{ this.infosPagaments.rsocial }}
        </h3>
        <h3>
          <strong>Número do documento: </strong>{{ this.infosPagaments.numdoc }}
        </h3>
        <h3>
          <strong>Código do contrato: </strong>{{ this.infosPagaments.codtit }}
        </h3>
        <h3>
          <strong>Valor total R$: </strong>{{ this.infosPagaments.valor }}
        </h3>
      </div>
      <div class="title is-4 box has-text-dark">
        <div class="media">
          <div class="media-content">
              <a :href="`https://mail.api-mplan.com.br/payments/gen/${cliente}/${numdoc}/${rsocial}`" target="_blank" class="button is-primary"><b>Download</b></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "Demonstrative of payments",

  data() {
    return {
      infosPagaments: {},
      cliente: '',
      numdoc: '',
      rsocial: ''

    };
  },
  mounted() {
    this.decodeUrl(this.getUrl());
  },
  methods: {
    getUrl() {
      return this.$route.query.payments
    },

    decodeUrl(url) {
      var urlDecode = JSON.parse(window.atob(url));
      this.infosPagaments = { ...urlDecode };
      this.cliente = urlDecode.cliente
      this.numdoc = urlDecode.numdoc
      this.rsocial = urlDecode.rsocial
    },
   
  },
};
</script>
